import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiSwitchRootFn = /* @__PURE__ */ createRecipe('multi-switch-root', {}, [])

const multiSwitchRootVariantMap = {}

const multiSwitchRootVariantKeys = Object.keys(multiSwitchRootVariantMap)

export const multiSwitchRoot = /* @__PURE__ */ Object.assign(memo(multiSwitchRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiSwitchRoot',
  __getCompoundVariantCss__: multiSwitchRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiSwitchRootVariantKeys,
  variantMap: multiSwitchRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiSwitchRootVariantKeys)
  },
  getVariantProps: multiSwitchRootFn.getVariantProps,
})